import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';

export interface FilterBarSelectOption {
  value: string;
  label: string;
}

export interface FilterBarSelect {
  id: string;
  label: string;
  value: string;
  options: FilterBarSelectOption[];
  onChange: (value: string) => void;
}

export interface FilterBarToggle {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export interface FilterBarProps {
  searchValue: string;
  searchPlaceholder?: string;
  onSearchChange: (value: string) => void;
  selects?: FilterBarSelect[];
  toggles?: FilterBarToggle[];
  className?: string;
}

export function FilterBar({
  searchValue,
  searchPlaceholder = 'Search…',
  onSearchChange,
  selects = [],
  toggles = [],
  className,
}: FilterBarProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-xl border border-[#EDEEF2] bg-white p-4 sm:flex-row sm:flex-wrap sm:items-end',
        className,
      )}
    >
      <label className={cn(portalDs.field, 'min-w-[220px] flex-1')}>
        <span className={portalDs.filterLabel}>Search</span>
        <input
          type="search"
          className={portalDs.input}
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </label>

      {selects.map((select) => (
        <label key={select.id} className={cn(portalDs.field, 'min-w-[160px]')}>
          <span className={portalDs.filterLabel}>{select.label}</span>
          <select
            className={portalDs.select}
            value={select.value}
            onChange={(event) => select.onChange(event.target.value)}
          >
            {select.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ))}

      {toggles.map((toggle) => (
        <label
          key={toggle.id}
          className="flex min-h-9 cursor-pointer items-center gap-3 self-end pb-0.5"
        >
          <span className="relative inline-flex h-5 w-9 shrink-0">
            <input
              type="checkbox"
              className="peer sr-only"
              checked={toggle.checked}
              onChange={(event) => toggle.onChange(event.target.checked)}
            />
            <span
              className="absolute inset-0 rounded-full bg-[#D9DBE3] transition-colors peer-checked:bg-[#2563EB]"
              aria-hidden
            />
            <span
              className="absolute left-[3px] top-[3px] size-3.5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] transition-transform peer-checked:translate-x-4"
              aria-hidden
            />
          </span>
          <span className="text-[13.5px] text-[#0D0F1A]">
            {toggle.label}
          </span>
        </label>
      ))}
    </div>
  );
}
